// src/index.ts
import { configure, openSession, closeSession, getSessionIdSafe, getUserIdSafe, sendIdentify } from './core';
import { setConsent as _setConsent, initConsent, setDNTPolicy, consentFlags } from './consent';
import { enqueue } from './transport';
import type { Config, EventPayload } from './types';
import { now } from './utils';
export * from './types';
export { reportBug } from './bug';

let initialized = false;

export function init(cfg: Config) {
    if (initialized) return;
    if (!cfg.user?.profile) {
        console.warn('[poulet] init skipped: user.profile is required to call /identify before ingest.');
        return;
    }
    setDNTPolicy(cfg.privacy?.dntRespect ?? true);
    initConsent(cfg.consent?.default ?? 'pending');
    configure(cfg);
    const identifyDone = sendIdentify(cfg.user.profile).then(() => {
        // allow session after identify completes
    });
    // ouverture paresseuse : dès qu’il y a visibilité/activité
    if (document.visibilityState === 'visible') identifyDone.then(() => openSession());
    document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'visible') {
            identifyDone.then(() => openSession());
            trackEvent('tab.visible', { visibility: 'visible' });
        } else {
            trackEvent('tab.hidden', { visibility: document.visibilityState });
        }
    });
    // Flush/close sur pagehide
    addEventListener('pagehide', () => {
        trackEvent('tab.closed', { reason: 'pagehide' });
        closeSession('pagehide');
    });
    initialized = true;
}

export function setConsent(flags: { analytics?: boolean; replay?: boolean }) {
    _setConsent(flags);
    if (document.visibilityState === 'visible') openSession();
}

export function trackEvent(name: string, props?: Record<string, unknown>) {
    const sessionId = getSessionIdSafe();
    if (!sessionId) return;
    const ev: EventPayload = {
        type: 'event',
        sessionId,
        ts: now(),
        userId: getUserIdSafe() || undefined,
        name,
        props,
        purpose: 'diagnostics',
    };
    enqueue(ev);
}

export function shutdown() {
    closeSession('shutdown');
}

export function getSessionId() {
    return getSessionIdSafe();
}

export function forgetMe() {
    // côté core : rien de persistant par défaut (queue en mémoire).
    // si tu ajoutes IndexedDB/localStorage pour queue offline, purge ici.
    // Pour l’exemple, on ne stocke pas persistantement.
    closeSession('shutdown');
}

export const _consentFlags = consentFlags;
